import React, { Component } from "react";
import { connect } from "react-redux";
import latinize from "latinize";
import {
  senfFileQuickAsw,
  RespostasRapidasida,
  addChat,
  ChangeChat,
  GetChatUser,
  addMessage,
  InsertUpload,
  SendNextAtd,
  createStatusAgent,
  CloseAttendant,
  ShowVisibleDetailsAtd,
  ShowVisibleNextAtd,
  MarkMessage,
  InsertAnotations,
  refreshReturnAtd,
  editAtendimentoAgent,
  addAtendimento,
  GetHistory,
  GetMarkstar,
  markstarRedux,
  CloseChat,
  SendNextChat,
  removeConversation,
  RemoveRemoteNotifier,
  EndcallConsultIndexAtd,
} from "../actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Highlighter from "react-highlight-words";
import Moment from "moment";
import ModalImage from "react-modal-image";
import {
  InviteChats,
  SendSocketTransferCallIn,
  sendtypinwebsocketchat,
} from "../actions/websocket";
import TimeCounterChatInternal from "./TimeCounterChatInternal";
import $ from "jquery";
import DEFAULT from "../build/images/default.png";
import AVI from "../build/images/avi-file.png";
import JPG from "../build/images/jpg-file.png";
import PDF from "../build/images/pdf-file.png";
import MP3 from "../build/images/mp3-file.png";
import LOADING from "../build/images/typing.gif";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/themes/light.css";
import _ from "lodash";
import ChatSimultComponent from "./ChatSimult";
import UserPhoto from "../components/UserPhoto/userphoto";

const { connection_platform } = require("../services/api");

var ipcurrent = "";
var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) != 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

var typingTimer;
var doneTypingInterval = 5000;
var digitando = 0;
var mensagensnaolidas = [];
var outroatendimento = [];

const { meses } = require("../services/data");

const mapStateToProps = (state) => {
  return {
    Typing: state.typing,
    RespostasRapidas: state.respostas,
    UserGroups: state.groups,
    UsersAgents: state.agents,
    Messages: state.messages,
    InfoUsers: state.informationusers,
    MsgReceived: state.msgreceived,
    ContactId: state.atendimento,
    IPCurrent: state.ipcurrent,
    StatusUpload: state.uploadfile,
    DisplayDetails: state.displaydetailsatd,
    StatusAgent: state.status,
    DisplayNextAtd: state.displaynextatd,
    AtdSimult: state.atdsimult,
    ChatSimult: state.chatsimult,
    Chat: state.chatinternal,
  };
};

function makeid(length) {
  var text = "";
  var possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  for (var i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

const mapDispatchToProps = (dispatch) => ({
  sendImageAsw: (makeid, message, author, infousers, contactid, typemsg) => {
    let time = Moment().format("HH:mm");
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          contactid.idatendimento,
          typemsg,
          "entregue",
          false
        )
      );
    }
  },

  sendFileAswSocket: (InfoUsers, ContactId, path, texto, makeid) => {
    if (path != "") {
      senfFileQuickAsw(InfoUsers, ContactId, path, texto, makeid);
    }
  },

  InviteChat: (
    makeid,
    message,
    author,
    infousers,
    chat,
    typemsg,
    msgsocket
  ) => {
    let time = Moment().format("HH:mm");
    let dia = Moment().format("DD");
    let mes = Moment().format("MM");
    mes = meses.indexOf(mes);
    dia = dia + " de " + meses[mes - 1];
    if (message != "") {
      dispatch(
        addMessage(
          makeid,
          message,
          author,
          time,
          chat.iduserout,
          typemsg,
          "enviado",
          false,
          dia
        ),
        InviteChats(infousers, chat.iduserout, msgsocket, author, makeid)
      );
    }
  },
  sendtyping: (typing, InfoUsers, Chat) => {
    if (digitando === 0) {
      sendtypinwebsocketchat(1, InfoUsers, Chat);
      digitando = 1;
      clearTimeout(typingTimer);
      typingTimer = setTimeout(doneTyping, doneTypingInterval);
    } else {
      doneTypingInterval = 5000;
    }

    function doneTyping() {
      digitando = 0;
      sendtypinwebsocketchat(0, InfoUsers, Chat);
    }
  },
  UploadFile: (data, InfoUsers, ContactId, caption, makeid, size) => {
    InsertUpload(data, InfoUsers, ContactId, caption, makeid, size)(dispatch);
  },
  ProximoChat: (proximoatd, novamensagem, chat, infousers) => {
    SendNextChat(proximoatd, novamensagem, chat, infousers)(dispatch);
  },
  ByeChat: (chat) => {
    dispatch(CloseChat(chat));
  },
  EndcallConsult: (event, agent) => {
    dispatch(EndcallConsultIndexAtd(event, agent));
  },
  RespostasRapidasida: (userid) => {
    RespostasRapidasida(userid)(dispatch);
  },
  InsertAnotationsIn: (idcdr, criticidade, comentario, userid) => {
    InsertAnotations(idcdr, criticidade, comentario, userid)(dispatch);
  },
  getHistoryChat: (userin, userout, datainit) => {
    dispatch(removeConversation(userout));
    GetChatUser(userin, userout, datainit)(dispatch);
  },
  ChangeChatSimult: (infouser, chat) => {
    let datatime = Moment().format("YYYY/MM/DD HH:mm:ss");
    dispatch(addChat(chat.iduserout, chat.agent, false, 0, 0, datatime));
    // ChangeChat(infouser,chat)
    dispatch(RemoveRemoteNotifier(chat.iduserout));
  },
});

class ChatInternal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileasw: [],
      arrowterm: 0,
      activeconsulta: false,
      expand_less_count: 0,
      buttonshowperioty: false,
      expand_more_count: 0,
      transfers: [],
      visible: "",
      searchText: "",
      groups: [],
      respostas: [],
      respostasinicial: [],
      agents: [],
      agentsinicial: [],
      selectedFile: null,
      loaded: 0,
      active: [],
      buttonfilterConsulted: false,
      keyGen: [],
      auxkeyGen: [],
      keyGan: ["LV", "BQ", "AT", "RV", "CHND"],
      auxkeyGan: ["LV", "BQ", "AT", "RV", "CHND"],
      marked: "Marcar Todos",
      checked: false,
      DescAnotacoes: [],
      criticidadeSelec: "",
      iconeCriticidade: "",
      idCriticidadeSelec: 0,
      SaveSucess2: false,
      showbuttondetails: " active",
      scroller: 0,
      auxIvr: [],
      atdsimult: [],
      messages: [],
      focus: false,
      contadormensagens: [],
      auxIvrRadio: 0,
      typing: [],
      periodicity: "Por período",
      userAgentSpecific: [],
    };
    this.handleClick = this.handleClick.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
    this.handleselectedFile = this.handleselectedFile.bind(this);
    this.filterList = this.filterList.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.ChangeChat = this.ChangeChat.bind(this);
  }

  ChangeChat(infouser, chat) {
    let iduserout = chat.iduserout;
    mensagensnaolidas[chat.iduserout] = 0;
    this.props.ChangeChatSimult(infouser, chat);
  }

  filterList(event, respostas) {
    var updatedList = respostas;
    updatedList = updatedList.filter(function (item) {
      let asw = item.qck_asw_keyword;
      let filtro = event.target.value;
      //let regex = /\{((?:\\.|[^{])*?)\}/g;
      let er = /[^a-z0-9]/gi;
      filtro = filtro.replace(er, "");
      //filtro = filtro.replace(/\\/g, "\\\\");
      let resultado = asw.search(filtro);
      return asw.toLowerCase().search(filtro.toLowerCase()) != -1;
    });
    this.setState({ respostas: updatedList });
  }

  componentDidUpdate(prevProps, prevState) {
    this.scrollDown();
  }

  scrollDown() {
    const { container } = this.refs;
    if (this.state.scroller != container.scrollHeight) {
      container.scrollTop = container.scrollHeight;
      this.state.scroller = container.scrollHeight;
    }
  }

  handleselectedFile(event, infousers, contactid) {
    let filesend = event.target.files[0];
    if (filesend != undefined) {
      this.setState({
        selectedFile: filesend,
        loaded: 0,
      });
      let data = new FormData();
      data.append("file", filesend, filesend.name);
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let str = msgsocket.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        document.getElementById("chat-message").innerHTML = "";
        this.props.UploadFile(
          data,
          infousers,
          contactid,
          msgweb,
          makeid(32),
          filesend.size
        );
      } else {
        this.props.UploadFile(
          data,
          infousers,
          contactid,
          "",
          makeid(32),
          filesend.size
        );
      }
    }
  }

  handleKeyUp(inf) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;

    if (tam >= this.state.arrowterm + 1) {
      elems[this.state.arrowterm].scrollIntoView(false);
      if (inf == "less") {
        if (this.state.arrowterm != 0) {
          this.state.arrowterm = this.state.arrowterm - 1;
          if (this.state.expand_less_count != 1)
            this.setState({
              expand_less_count: this.state.expand_less_count - 1,
            });
        }
      } else {
        this.state.arrowterm = this.state.arrowterm + 1;
        if (this.state.expand_less_count != this.state.expand_more_count)
          this.setState({
            expand_less_count: this.state.expand_less_count + 1,
          });
      }
    } else {
      if (elems[this.state.arrowterm]) {
        this.state.arrowterm = 1;
        elems[this.state.arrowterm].scrollIntoView(false);
      }
    }
    if (tam === this.state.arrowterm) {
      if (inf == "less") {
        this.state.arrowterm = this.state.arrowterm - 1;
        this.setState({ expand_less_count: this.state.expand_less_count - 1 });
      }
    }
  }

  componentDidMount() {
    var indexElemAtual = 0;
    var libBusca = null;
    var armazenador = [];
    var contador = null;
    var elems = null;
    this.props.RespostasRapidasida(this.props.InfoUsers.id);
    var topBarHeight = $("header").outerHeight(true);
    var windowHeight = $("body").outerHeight(true);
    var activeChatsHeight = $(".active-chats").outerHeight(true);
    var canvasHeight = windowHeight - topBarHeight - activeChatsHeight;
    var proximosAtendimentosHeight = windowHeight - topBarHeight;

    $("#column1, #column2,#column3").css(
      "height",
      proximosAtendimentosHeight + "px"
    );

    this.setState({ filterAgent: "", filterGroup: "" });
  }

  ByeChat(event, chat, infousers, chatsimult, novamensagem, reason) {
    event.preventDefault();
    this.props.ByeChat(chat);

    delete mensagensnaolidas[chat.iduserout];
    delete outroatendimento[chat.iduserout];

    if (chatsimult.length > 1) {
      let i = 0;
      if (chatsimult[0].iduserout == chat.iduserout) i = 1;
      this.props.ProximoChat(chatsimult[i], novamensagem, chat, infousers);
    }
    //this.props.EndcallConsult(event, chat);
  }

  DisplayFilterConsulted(e) {
    e.preventDefault();
    this.setState({ buttonfilterConsulted: !this.state.buttonfilterConsulted });
  }

  changeAgent(e, teste) {
    this.setState({ filterAgent: e.target.value });
    if (e.target.value != "") {
      this.setState({ keyGan: [] });
    }
    if (e.target.value === "") {
      this.setState({ keyGan: this.state.auxkeyGan });
    }
  }

  filterGroup(e, idgroup) {
    if (e.target.checked) {
      this.setState({
        keyGen: this.state.keyGen.concat([idgroup]),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.concat([idgroup]),
      });
    } else {
      this.setState({
        keyGen: this.state.keyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      this.setState({
        auxkeyGen: this.state.auxkeyGen.filter(function (val) {
          return val != idgroup;
        }),
      });
      this.setState({ marked: "Marcar Todos" });
      this.setState({ checked: false });
    }
  }

  GiveBackCheckbox(e, serviceinid) {
    if (e.target.checked) {
      this.setState({
        auxIvr: this.state.auxIvr.concat([serviceinid]),
      });
    } else {
      this.setState({
        auxIvr: this.state.auxIvr.filter(function (val) {
          return val != serviceinid;
        }),
      });
    }
  }

  GiveBackRadio(e, idatendimento, todosids, simult) {
    var teste = [];
    this.setState({ auxTransferRadio: simult });
    for (let i = 0; i < todosids.length; i++) {
      teste.push(todosids[i].idatendimento);
      var myCheckbox = document.getElementById(
        "radio" + todosids[i].idatendimento
      );
      myCheckbox.checked = false;
    }
    var myCheckbox = document.getElementById("radio" + idatendimento);
    myCheckbox.checked = true;
  }

  filterState(e, status) {
    if (e.target.checked) {
      this.setState({
        keyGan: this.state.keyGan.concat([status]),
      });
      this.setState({
        auxkeyGan: this.state.auxkeyGan.concat([status]),
      });
    } else {
      this.setState({
        keyGan: this.state.keyGan.filter(function (val) {
          return val != status;
        }),
      });
      this.setState({
        auxkeyGan: this.state.auxkeyGan.filter(function (val) {
          return val != status;
        }),
      });
    }
  }

  renderPopover2 = (e, AtdSimult, InfoUsers, Chat) => (
    <div id="popover-return-ura">
      <div className="popover">
        <div className="popover__header">
          <i className="fas fa-share-square"></i>
          <span>Gostaria de transferir qual atendimento?</span>
        </div>
        <div className="popover__body">
          <div className="options-list">
            <ul>
              {/* {AtdSimult.map(simult => (
                      (() => { 
                          return (
                            <li key={simult.idatendimento}><input onChange={event => this.GiveBackRadio(event, simult.idatendimento, AtdSimult, simult)} type="radio" name={"radio"+simult.idatendimento} id={"radio"+simult.idatendimento}/><label htmlFor={"radio"+simult.idatendimento}>{simult.telefone}</label></li>
                          );
                      })()
                    ))} */}
            </ul>
          </div>
        </div>
        <div className="popover__footer">
          <a
            href="#"
            onClick={(event) =>
              this.SetTransferInteration(
                event,
                InfoUsers,
                Chat.iduserout,
                Chat.agent
              )
            }
            className="btn btn-primary btn-block"
          >
            Transferir Interação
          </a>
        </div>
      </div>
    </div>
  );

  SetTransferInteration(e, infousers, iduserin, userin) {
    var array = this.state.auxTransferRadio;

    if (array) {
      const socket = SendSocketTransferCallIn(
        infousers.id,
        array.idatendimento,
        array.direction,
        array.subservico,
        array.idatendimento,
        iduserin,
        userin
      );
    }
  }

  handleClick() {
    this.setState((state) => ({
      activeconsulta: !state.activeconsulta,
      searchText: "",
      expand_less_count: 0,
      expand_more_count: 0,
    }));
  }

  MoreChats(e) {
    e.preventDefault();
    this.setState({ buttonMore: !this.state.buttonMore });
  }

  ShowPerioty(e) {
    e.preventDefault();
    this.setState({ buttonshowperioty: !this.state.buttonshowperioty });
  }

  DisplayQuickAnswer(e) {
    e.preventDefault();
    this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
    const { RespostasRapidas } = this.props;
    this.state.respostasinicial = RespostasRapidas.respostas;
    this.state.respostas = this.state.respostasinicial;
  }

  InsertQuickAnswer(
    event,
    texto,
    editable,
    mimetypeid,
    filepath,
    InfoUsers,
    ContactId
  ) {
    event.preventDefault();
    document.getElementById("chat-message").innerText = texto;
    if (mimetypeid != 1) {
      let gerarnomearquivo = makeid(32);
      let photo = {
        uri: filepath,
        type: "application/pdf",
        name: gerarnomearquivo + ".pdf",
      };

      let fileencryp = new FormData();
      fileencryp.append("file", photo, gerarnomearquivo + ".pdf");
      let arrayfile = [filepath, texto, mimetypeid];
      this.setState({ fileasw: [] });
      this.setState({ fileasw: arrayfile });
    } else {
      this.setState({ fileasw: [] });
      if (editable == false) {
        document.getElementById("chat-message").disabled = true;
      } else {
        document.getElementById("chat-message").disabled = false;
        document.getElementById("chat-message").focus();
      }
    }
    this.setState({ buttonQuickAnswer: !this.state.buttonQuickAnswer });
  }

  ButtonSendMessage(event, author, InfoUsers, Chat, typemsg) {
    event.preventDefault();
    document.getElementById("chat-message").disabled = false;
    let msgweb = document.getElementById("chat-message").innerText;
    let msgsocket = document.getElementById("chat-message").innerText;

    let infosendfile = this.state.fileasw;

    if (
      this.state.fileasw != null &&
      infosendfile[2] != 1 &&
      infosendfile.length > 0
    ) {
      msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
      msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        this.props.sendFileAswSocket(
          InfoUsers,
          Chat,
          infosendfile[0],
          msgweb,
          makeid(32)
        );
        this.props.sendImageAsw(
          makeid(32),
          " ~¿" + msgweb + "~¿" + infosendfile[0],
          InfoUsers.id,
          InfoUsers,
          Chat,
          1
        );
      }
    } else {
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        this.props.InviteChat(
          makeid(32),
          msgweb,
          InfoUsers.id,
          InfoUsers,
          Chat,
          typemsg,
          msgsocket
        );
      }
    }
    this.scrollDown();
    document.getElementById("chat-message").innerHTML = "";
    this.textInput.focus();
  }

  handleKeyPress = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  handleKeyDown = (event) => {
    var el = document.getElementById("chat-message");
    el.addEventListener("keypress", function (event) {
      if (event.keyCode == 13 && !event.shiftKey) {
        event.preventDefault();
        return false;
      }
    });
    el.addEventListener("keydown", function (event) {
      if (event.keyCode == 33) {
        event.preventDefault();
        return false;
      }
    });
  };

  handleOnChange(event, InfoUsers, Chat) {
    if (event.key === "Enter" && event.shiftKey === false) {
      let teste = document.getElementsByClassName("chat-message");
      let msgweb = document.getElementById("chat-message").innerText;
      let msgsocket = document.getElementById("chat-message").innerText;
      let str = msgweb.replace(/\s/g, "");
      if (str != "") {
        msgweb = msgweb.trim();
        msgweb = msgweb.replace(/(?:\r\n|\r|\n)/gm, "\\n");
        msgsocket = msgsocket.trim();
        msgsocket = msgsocket.replace(/\n|\r\n/gi, "¿");
        this.props.InviteChat(
          makeid(32),
          msgweb,
          InfoUsers.id,
          InfoUsers,
          Chat,
          "0",
          msgsocket
        );
        document.getElementById("chat-message").innerHTML = "";
        this.scrollDown();
        this.props.sendtyping(0, InfoUsers, Chat);
      }
    } else {
      this.props.sendtyping(1, InfoUsers, Chat);
    }
  }

  GetTermText(event) {
    var elems = document.getElementsByTagName("mark");
    var tam = elems.length;
    this.setState({
      searchText: event.target.value,
      arrowterm: 0,
      expand_more_count: tam,
    });

    if (tam === 0) {
      this.setState({ expand_less_count: 0 });
    } else {
      this.setState({ expand_less_count: 1 });
    }
  }

  GetHistoryChat(e, action, userin, userout, periodicity) {
    var date = Moment().format("YYYY-MM-DD 00:00:00");
    switch (action) {
      case "1":
        date = Moment().format("YYYY-MM-DD 00:00:00");
        this.setState({ periodicity: periodicity });
        break;
      case "2":
        date = Moment().subtract(1, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        this.setState({ periodicity: periodicity });
        break;
      case "3":
        date = Moment().subtract(7, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        this.setState({ periodicity: periodicity });
        break;
      case "4":
        date = Moment().subtract(14, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        this.setState({ periodicity: periodicity });
        break;
      case "5":
        date = Moment().subtract(31, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        this.setState({ periodicity: periodicity });
        break;
      case "6":
        date = Moment().subtract(62, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        this.setState({ periodicity: periodicity });
        break;
      case "7":
        date = Moment().subtract(93, "days");
        date = date.format("YYYY-MM-DD 00:00:00");
        this.setState({ periodicity: periodicity });
        break;
    }
    this.props.getHistoryChat(userin, userout, date);
  }

  render() {
    const {
      Typing,
      UsersAgents,
      Messages,
      ContactId,
      ChatSimult,
      Chat,
      InfoUsers,
      IPCurrent,
      StatusUpload,
      RespostasRapidas,
      UserGroups,
      AtdSimult,
    } = this.props;
    const { searchText } = this.state;
    const searchWords = searchText.split(/\s/).filter((word) => word);
    let input;
    var typing_w = "";
    var dia = "";
    var auxdia = "";

    if (Typing.length != 0) {
      this.state.typing = Typing;
    }

    if (UsersAgents.length != 0) {
      this.state.lsusersatd = UsersAgents;
    } else {
      this.state.lsusersatd = [];
    }

    this.state.typing.map((typingtodo) => {
      if (
        typingtodo.typing == "1" &&
        typingtodo.idatendimento == Chat.iduserout
      ) {
        typing_w = (
          <div className="message left" style={{ marginTop: "20px" }}>
            <div className="bubble">
              <img src={LOADING} alt="" className="bubble__typing" width="48" />
            </div>
          </div>
        );
      }
    });

    const { props, onScroll } = this;

    if (Messages.length != 0 && ChatSimult != 0) {
      var NovaMensagem = Messages[Chat.iduserout];
      var Contador = [];

      if (NovaMensagem === undefined) {
        var NovaMensagem = [];
      }
    } else {
      var NovaMensagem = [];
    }

    if (Messages.length != 0) this.state.messages = Messages;

    if (UsersAgents.length != 0) {
      this.state.agents = UsersAgents;
      if (this.state.keyGen != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGen.includes(agent.id_grupo)
        );
      }
      if (this.state.keyGan != "") {
        this.state.agents = this.state.agents.filter((agent) =>
          this.state.keyGan.includes(agent.status_sip)
        );
      }
    }

    if (UserGroups.length != 0) {
      this.state.groups = UserGroups.groups;
    }

    if (AtdSimult.length != 0) {
      this.state.atdsimult = AtdSimult;
    }

    if (ChatSimult.length != 0) {
      this.state.chatsimult = ChatSimult;
    }

    if (Chat.length != 0) {
      this.state.chat = Chat;
    }

    const list = this.state.agents || [];
    this.state.agents = _.filter(list, (agent) => {
      let arrayAgent = [
        agent.username,
        agent.desc_grupo,
        agent.ramal,
        agent.razao_bloqueio,
      ];
      return !_.isEmpty(this.state.filterAgent)
        ? arrayAgent
            .toString()
            .toLowerCase()
            .indexOf(this.state.filterAgent.toString().toLowerCase()) > -1
        : true;
    });

    if (UsersAgents.length != 0 && Chat.length != 0) {
      this.state.userAgentSpecific = this.state.lsusersatd.filter(
        (user) =>
          parseInt(Chat.iduserout) == parseInt(user.iduser) &&
          parseInt(Chat.ramal) == parseInt(user.ramal)
      );
    } else {
      this.state.userAgentSpecific = [];
    }

    return (
      <div id="column2" className="chat-page column split column-chat">
        <div
          className="popover-box block no-margin-bottom"
          id="popover-all-notes"
        >
          <div className="block-header">
            <h1>
              Anotações <FontAwesomeIcon icon={["fas", "exclamation-circle"]} />
            </h1>
            <div className="close">
              <FontAwesomeIcon icon={["far", "times-circle"]} />
            </div>
          </div>
          <div className="block-content">
            <div className="column-user-details column-user-details active">
              <div className="user-name">André Luiz Batista Aureliano</div>
              <div className="user-time">
                <FontAwesomeIcon icon={["far", "clock"]} />
                <span className="time">00:00:00</span> na fila
              </div>
            </div>
          </div>
        </div>
        <div className="chat-wrapper is-visible">
          <div className="block full-height no-margin-bottom" id="chat">
            <div className="block-header">
              <div className="column-user-details column-user-details active">
                {/* <div className="user-photo">
                  <img src={DEFAULT} alt="" />
                </div> */}
                <UserPhoto
                  size="large"
                  link={Chat.imgUser ? Chat.imgUser : false}
                />
                <div className="wrapper-user">
                  <div className="user-name is-poppins">
                    <span className="user-name__channel"></span>
                    {Chat.agent}
                  </div>

                  {/* <div className="status-info">Online</div> */}
                  {/* this.state.lsusersatd */}
                  {this.state.userAgentSpecific.map((user) =>
                    (() => {
                      if (parseInt(Chat.iduserout) == parseInt(user.iduser)) {
                        let duracao = "";
                        if (user.duration) {
                          let arrayCompA = user.duration.split("-");
                          let datatimeCompA = Moment().format(
                            "YYYY/MM/DD HH:mm:ss"
                          );
                          var valorDiferenca = parseInt(
                            Math.abs(Math.round(IPCurrent.difftime))
                          );

                          if (parseInt(IPCurrent.difftime) < 0) {
                            datatimeCompA = Moment()
                              .subtract(valorDiferenca, "seconds")
                              .format("YYYY/MM/DD HH:mm:ss");
                          } else {
                            datatimeCompA = Moment()
                              .add(valorDiferenca, "seconds")
                              .format("YYYY/MM/DD HH:mm:ss");
                          }

                          let dataStatusA = Moment(
                            arrayCompA[0],
                            "DD/MM/YYYY HH:mm:ss"
                          ).format("YYYY/MM/DD HH:mm:ss");
                          duracao = Moment(datatimeCompA).diff(
                            dataStatusA,
                            "seconds"
                          );
                        }

                        if (user.status_sip === null || user.status === null) {
                          return (
                            <div className="user-infos" key={user.iduser}>
                              <div className="status-info">Inativo</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">00:00:00</span>
                              </div>
                            </div>
                          );
                        } else if (
                          user.status_sip === "LV" &&
                          user.status === "LV"
                        ) {
                          return (
                            <div className="user-infos" key={user.iduser}>
                              <div className="status-info">Livre</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">
                                  <TimeCounterChatInternal
                                    horario={parseInt(duracao)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        } else if (
                          user.status_sip === "LV" &&
                          user.status === "AT"
                        ) {
                          return (
                            <div className="user-infos">
                              <div className="status-info">Ativo</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">
                                  <TimeCounterChatInternal
                                    horario={parseInt(duracao)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        } else if (
                          user.status_sip === "RV" &&
                          user.status === "ATOS"
                        ) {
                          return (
                            <div className="user-infos">
                              <div className="status-info">Ativo</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">
                                  <TimeCounterChatInternal
                                    horario={parseInt(duracao)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        } else if (
                          user.status_sip === "LV" &&
                          user.status === "RV"
                        ) {
                          return (
                            <div className="user-infos">
                              <div className="status-info">Ativo</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">
                                  <TimeCounterChatInternal
                                    horario={parseInt(duracao)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        } else if (
                          user.status_sip === "ACW" &&
                          user.status === "ACW"
                        ) {
                          return (
                            <div className="user-infos">
                              <div className="status-info">AfterCallWork</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">
                                  <TimeCounterChatInternal
                                    horario={parseInt(duracao)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        } else if (
                          user.status_sip === "BQ" &&
                          user.razao_bloqueio != ""
                        ) {
                          return (
                            <div className="user-infos">
                              <div className="status-info">Pausado</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">
                                  <TimeCounterChatInternal
                                    horario={parseInt(duracao)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        } else if (
                          user.status_sip === "CHND" &&
                          user.razao_bloqueio != "CHND"
                        ) {
                          return (
                            <div className="user-infos">
                              <div className="status-info">Ativo</div>
                              <div className="user-time">
                                {" "}
                                <span className="time">
                                  <TimeCounterChatInternal
                                    horario={parseInt(duracao)}
                                    key={user.iduser + "_" + user.status_sip}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        } else {
                          return (
                            <div className="user-infos">
                              <div className="status-info">Inativo</div>
                              <div className="user-time">
                                <span className="time">00:00:00</span>
                              </div>
                            </div>
                          );
                        }
                      }
                    })()
                  )}
                </div>
              </div>
              <div className="column-actions column-actions--right">
                {/* <Popover trigger="click" interactive={true} content={this.renderPopover2(this,AtdSimult, InfoUsers, Chat)}><button type="button" className="btn action with-icon with-dropdown fix-center tippy-popover" id="chat-action-transfer" data-tooltip="Transferir Chamada" data-template="popover-return-ura"><i className="material-icons">phone_forwarded</i></button></Popover> */}
                <a
                  onClick={this.handleClick}
                  className="btn action with-icon tippy-default"
                  id="chat-action-search"
                  data-tippy-content="Pesquisar na conversa"
                >
                  <i className="material-icons">search</i>
                </a>
                <a
                  onClick={(event) =>
                    this.ByeChat(event, Chat, InfoUsers, ChatSimult, Messages)
                  }
                  className="btn action with-icon tippy-default"
                  id="chat-action-shutdown"
                  data-tippy-content="Encerrar atendimento"
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.75 12C22.75 17.93 17.93 22.75 12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12ZM2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12Z"
                      fill="#757575"
                    />
                    <path
                      d="M15.5801 14.8306C15.5801 15.0206 15.5101 15.2106 15.3601 15.3606C15.0701 15.6506 14.5901 15.6506 14.3001 15.3606L8.64011 9.70062C8.35011 9.41062 8.35011 8.93063 8.64011 8.64063C8.93011 8.35063 9.41011 8.35063 9.70011 8.64063L15.3601 14.3006C15.5101 14.4406 15.5801 14.6406 15.5801 14.8306Z"
                      fill="#757575"
                    />
                    <path
                      d="M15.5801 9.17063C15.5801 9.36063 15.5101 9.55062 15.3601 9.70062L9.70011 15.3606C9.41011 15.6506 8.93011 15.6506 8.64011 15.3606C8.35011 15.0706 8.35011 14.5906 8.64011 14.3006L14.3001 8.64063C14.5901 8.35063 15.0701 8.35063 15.3601 8.64063C15.5101 8.79063 15.5801 8.98063 15.5801 9.17063Z"
                      fill="#757575"
                    />
                  </svg>
                </a>
              </div>
              <div
                className={
                  this.state.activeconsulta
                    ? "block-header__search-box is-active"
                    : "block-header__search-box"
                }
              >
                <div className="block-header__search-box-nav">
                  <div
                    className="pausa"
                    onClick={(event) => this.ShowPerioty(event)}
                  >
                    <button
                      className={
                        this.state.buttonshowperioty
                          ? "pausa__select-btn active"
                          : "pausa__select-btn"
                      }
                    >
                      {this.state.periodicity}
                      <i className="material-icons">chevron_right</i>
                    </button>
                    <div
                      className={
                        this.state.buttonshowperioty
                          ? "pausa__select active"
                          : "pausa__select"
                      }
                    >
                      <ul className="pausa__list">
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "1",
                              InfoUsers.id,
                              Chat.iduserout,
                              "Hoje"
                            )
                          }
                        >
                          <p className="pausa__label">Hoje</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "2",
                              InfoUsers.id,
                              Chat.iduserout,
                              "Ontem"
                            )
                          }
                        >
                          <p className="pausa__label">Ontem</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "3",
                              InfoUsers.id,
                              Chat.iduserout,
                              "Há uma semana"
                            )
                          }
                        >
                          <p className="pausa__label">Há uma semana</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "4",
                              InfoUsers.id,
                              Chat.iduserout,
                              "Há duas semanas"
                            )
                          }
                        >
                          <p className="pausa__label">Há duas semanas</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "5",
                              InfoUsers.id,
                              Chat.iduserout,
                              "Há 1 mês"
                            )
                          }
                        >
                          <p className="pausa__label">Há 1 mês</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "6",
                              InfoUsers.id,
                              Chat.iduserout,
                              "Há 2 meses"
                            )
                          }
                        >
                          <p className="pausa__label">Há 2 meses</p>
                        </li>
                        <li
                          className="pausa__item"
                          onClick={(event) =>
                            this.GetHistoryChat(
                              event,
                              "7",
                              InfoUsers.id,
                              Chat.iduserout,
                              "Há 3 meses"
                            )
                          }
                        >
                          <p className="pausa__label">Há 3 meses</p>
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div className="block-header__search-box-content-input">
                    <input
                      id="searchTerms"
                      name="searchTerms"
                      autoFocus={true}
                      onChange={(event) => this.GetTermText(event)}
                      type="text"
                      placeholder="Pesquisar mensagens..."
                      className="block-header__search-box-input"
                    />

                    <div className="block-header__search-box-content-count">
                      {this.state.expand_less_count} de{" "}
                      {this.state.expand_more_count}
                    </div>
                  </div>

                  <div className="block-header__search-box-content-icon">
                    <a
                      onClick={(event) => this.handleKeyUp("less")}
                      className="block-header__search-box-icon material-icons"
                    >
                      expand_less
                    </a>
                    <a
                      onClick={(event) => this.handleKeyUp("more")}
                      className="block-header__search-box-icon material-icons"
                    >
                      expand_more
                    </a>
                  </div>
                  <button
                    onClick={this.handleClick}
                    className="block-header__search-box-button"
                  >
                    Concluir
                  </button>
                </div>
              </div>
            </div>

            <div className="block-content chat-canvas" ref="container">
              {NovaMensagem.map((message, i) => {
                var positmessage1 = "message left";
                var positmessage2 = "fav fav--left";
                if (parseInt(message.author) === parseInt(InfoUsers.id)) {
                  positmessage1 = "message right";
                  positmessage2 = "fav fav--right";
                }
                if (message.dia != auxdia) {
                  dia = message.dia;
                  auxdia = message.dia;
                } else {
                  auxdia = message.dia;
                  dia = "";
                }
                var verifystar = this.state.active;
                var mensagem_tratada = message.message.replace(/¿/gi, "\n");
                if (message.typemsg === "2") {
                  var mensagem_tratada = mensagem_tratada.replace(
                    /§/gi,
                    "\r\n"
                  );
                }
                if (
                  parseInt(message.author) === InfoUsers.id &&
                  Chat.iduserout === message.iduserout &&
                  message.typemsg === "0"
                )
                  return (
                    <div key={i} className={positmessage1}>
                      <div className="time">{dia}</div>
                      <div className="message__container">
                        <div className="bubble">
                          <div className="bubble-user-name">Atendente</div>
                          <div
                            className="text"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            <Highlighter
                              highlightClassName="YourHighlightClass1"
                              activeIndex="YourHighlightClass1"
                              activeClassName="YourHighlightClass1"
                              className="NovClass"
                              searchWords={searchWords}
                              textToHighlight={mensagem_tratada}
                              sanitize={latinize}
                            />
                            <span className="text__end-spacing"></span>
                          </div>
                          <div className="bubble__info-content">
                            <div
                              className="fav fav--inside fav--right"
                              style={{ display: "none" }}
                            >
                              <i className="material-icons fav-icon">
                                star_border
                              </i>
                            </div>
                            <div className="bubble__info-content__time">
                              {message.data}
                            </div>
                            {(() => {
                              if (positmessage1 != "message left") {
                                return (
                                  <div
                                    className={
                                      "message-info message-info--" +
                                      message.statusmsg
                                    }
                                  >
                                    <i className="material-icons">done_all</i>
                                  </div>
                                );
                              }
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                else if (
                  parseInt(Chat.iduserout) === parseInt(message.contactid) &&
                  message.typemsg === "0"
                )
                  return (
                    <div key={i} className={positmessage1}>
                      <div className="time">{dia}</div>
                      <div className="message__container">
                        <div className="bubble">
                          <div
                            className={
                              message.favorite === "true"
                                ? positmessage2 + " active"
                                : positmessage2
                            }
                          >
                            {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                          </div>
                          <div
                            className="text"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            <Highlighter
                              highlightClassName="YourHighlightClass"
                              searchWords={searchWords}
                              autoEscape={true}
                              textToHighlight={mensagem_tratada}
                              sanitize={latinize}
                            />
                            <span className="text__end-spacing"></span>
                          </div>
                          <div className="bubble__info-content">
                            <div
                              className="fav fav--inside fav--right"
                              style={{ display: "none" }}
                            >
                              <i className="material-icons fav-icon">
                                star_border
                              </i>
                            </div>
                            <div className="bubble__info-content__time">
                              {message.datatime}
                            </div>
                            {(() => {
                              if (positmessage1 != "message left") {
                                return (
                                  <div
                                    className={
                                      "message-info message-info--" +
                                      message.statusmsg
                                    }
                                  >
                                    <i className="material-icons">done_all</i>
                                  </div>
                                );
                              }
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                else if (
                  Chat.iduserout === message.iduserout &&
                  message.typemsg === "2"
                )
                  return (
                    <div key={i} className={positmessage1}>
                      <div className="time">{dia}</div>
                      <div className="message__container">
                        <div className="bubble">
                          <div
                            className={
                              message.favorite === "true"
                                ? positmessage2 + " active"
                                : positmessage2
                            }
                          ></div>
                          <div
                            className="text"
                            style={{ whiteSpace: "pre-line" }}
                          >
                            <Highlighter
                              highlightClassName="YourHighlightClass"
                              searchWords={searchWords}
                              autoEscape={true}
                              textToHighlight={mensagem_tratada}
                              sanitize={latinize}
                            />
                            <span className="text__end-spacing"></span>
                          </div>
                          <div className="bubble__info-content__time">
                            {message.data}
                          </div>
                          {(() => {
                            if (positmessage1 != "message left") {
                              return (
                                <div
                                  className={
                                    "message-info message-info--" +
                                    message.statusmsg
                                  }
                                >
                                  <i className="material-icons">done_all</i>
                                </div>
                              );
                            }
                          })()}
                        </div>
                      </div>
                    </div>
                  );
                else if (
                  Chat.iduserout === message.iduserout &&
                  message.typemsg === "1"
                )
                  var get_json = message.message;
                let separadorurlcaption = get_json.split("~¿");
                let thumbnail = separadorurlcaption[0];
                let caption = separadorurlcaption[1];
                let size = separadorurlcaption[3];
                if (caption) caption = caption.replace(/¿/gi, "\r\n");
                if (caption == "null") caption = "";
                let url = separadorurlcaption[2];
                let separador = url.split(".");
                let get_name = separador[0].split("/");
                let verificarexistencia = "";

                // eslint-disable-next-line default-case
                switch (separador[1].toLowerCase()) {
                  case "jpeg":
                  case "png":
                  case "jpg":
                    return (
                      <div className={positmessage1} key={message.id}>
                        {(() => {
                          if (message.dia != auxdia) {
                            return <div className="time">{dia}</div>;
                          }
                        })()}
                        <div className="bubble">
                          <div
                            className={
                              message.favorite === "true"
                                ? positmessage2 + " active"
                                : positmessage2
                            }
                          >
                            {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                          </div>
                          <div className="bubble-media">
                            <div className="bubble-media__image">
                              <ModalImage
                                small={
                                  connection_platform.type_connect +
                                  "://" +
                                  ipcurrent +
                                  url
                                }
                                large={
                                  connection_platform.type_connect +
                                  "://" +
                                  ipcurrent +
                                  url
                                }
                                alt={get_name[6]}
                                hideDownload={true}
                                className="bubble-media__image-file"
                              />
                              {/* <img className="bubble-media__image-file" src={"http://"+ipcurrent+url} alt="" /> */}
                            </div>
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={JPG}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  {get_name[6]}
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">{size}</span>{" "}
                                  •{" "}
                                  <span className="fileinfo__type">
                                    {separador[1].toUpperCase()}
                                  </span>
                                </div>
                              </span>
                              {(() => {
                                if (InfoUsers.permdownload === true) {
                                  return (
                                    <div className="bubble-media__download">
                                      <a
                                        href={
                                          connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          url
                                        }
                                        target="_blank"
                                        download
                                        className="bubble-media__btnDownload"
                                      >
                                        <i className="material-icons">
                                          get_app
                                        </i>
                                      </a>
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                          <div className="text">{caption}</div>
                        </div>
                      </div>
                    );

                    break;
                  case "pdf":
                    if (thumbnail === " ") {
                      verificarexistencia = "";
                    } else {
                      verificarexistencia = (
                        <div className="bubble-media__image">
                          <ModalImage
                            small={
                              connection_platform.type_connect +
                              "://" +
                              ipcurrent +
                              thumbnail
                            }
                            large={
                              connection_platform.type_connect +
                              "://" +
                              ipcurrent +
                              thumbnail
                            }
                            alt={get_name[6]}
                            hideDownload={true}
                            className="bubble-media__image-file"
                          />
                        </div>
                      );
                    }

                    return (
                      <div className={positmessage1} key={message.id}>
                        {(() => {
                          if (message.dia != auxdia) {
                            return <div className="time">{dia}</div>;
                          }
                        })()}
                        <div className="bubble">
                          <div
                            className={
                              message.favorite === "true"
                                ? positmessage2 + " active"
                                : positmessage2
                            }
                          >
                            {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                          </div>
                          <div className="bubble-media">
                            {verificarexistencia}
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={PDF}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  {get_name[6]}
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">{size}</span>{" "}
                                  •{" "}
                                  <span className="fileinfo__type">
                                    {separador[1].toUpperCase()}
                                  </span>
                                </div>
                              </span>
                              {(() => {
                                if (InfoUsers.permdownload === true) {
                                  return (
                                    <div className="bubble-media__download">
                                      <a
                                        href={
                                          connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          url
                                        }
                                        target="_blank"
                                        download
                                        className="bubble-media__btnDownload"
                                      >
                                        <i className="material-icons">
                                          get_app
                                        </i>
                                      </a>
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                          <div className="text">{caption}</div>
                        </div>
                      </div>
                    );
                    break;
                  case "xls":
                  case "xlsx":
                  case "xlsm":
                  case "doc":
                  case "docx":
                  case "ppt":
                  case "pptx":
                    return (
                      <div className={positmessage1} key={message.id}>
                        <div className="time">{message.datatime}</div>
                        <div className="bubble">
                          <div
                            className={
                              message.favorite === "true"
                                ? positmessage2 + " active"
                                : positmessage2
                            }
                          >
                            {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                          </div>
                          <div className="bubble-media">
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__image-file"
                                  src={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    url
                                  }
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  {get_name[6]}
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">{size}</span>{" "}
                                  •{" "}
                                  <span className="fileinfo__type">
                                    {separador[1].toUpperCase()}
                                  </span>
                                </div>
                              </span>
                              {(() => {
                                if (InfoUsers.permdownload === true) {
                                  return (
                                    <div className="bubble-media__download hide">
                                      <a
                                        href={
                                          connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          url
                                        }
                                        download
                                        className="bubble-media__btnDownload"
                                      ></a>
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                    break;
                  case "wav":
                  case "mp3":
                  case "ogg":
                  case "mpeg":
                    return (
                      <div className={positmessage1} key={message.id}>
                        {(() => {
                          if (message.dia != auxdia) {
                            return <div className="time">{dia}</div>;
                          }
                        })()}
                        <div className="bubble">
                          <div
                            className={
                              message.favorite === "true"
                                ? positmessage2 + " active"
                                : positmessage2
                            }
                          >
                            {/* <i onClick={event => this.markstar2(message.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                          </div>
                          <div className="bubble-media">
                            <div className="bubble-media__playerBar">
                              <audio controls>
                                <source
                                  src={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    url
                                  }
                                  type="audio/ogg"
                                />
                                <source
                                  src={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    url
                                  }
                                  type="audio/mpeg"
                                />
                                Your browser.
                              </audio>
                            </div>
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={MP3}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  {get_name[6]}
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">{size}</span>{" "}
                                  •{" "}
                                  <span className="fileinfo__type">
                                    {separador[1].toUpperCase()}
                                  </span>
                                </div>
                              </span>
                              {(() => {
                                if (InfoUsers.permdownload === true) {
                                  return (
                                    <div className="bubble-media__download">
                                      <a
                                        href={
                                          connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          url
                                        }
                                        target="_blank"
                                        download
                                        className="bubble-media__btnDownload"
                                      >
                                        <i className="material-icons">
                                          get_app
                                        </i>
                                      </a>
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                    break;
                  case "mp4":
                    return (
                      <div className={positmessage1} key={message.id}>
                        <div className="time">{message.datatime}</div>
                        <div className="bubble">
                          <div
                            className={
                              message.favorite === "true"
                                ? positmessage2 + " active"
                                : positmessage2
                            }
                          >
                            {/* <i onClick={event => this.markstar2(me  ssage.messageid, InfoUsers.id, message.favorite, Chat.iduserout)} className="material-icons fav-icon">{message.favorite === 'true' ?  "star" : "star_border"}</i> */}
                          </div>
                          <div className="bubble-media">
                            <div className="bubble-media__video">
                              <video
                                className="bubble-media__video-frame"
                                controls
                              >
                                <source
                                  className="bubble-media__video-file"
                                  src={
                                    connection_platform.type_connect +
                                    "://" +
                                    ipcurrent +
                                    url
                                  }
                                  type="video/mp4"
                                />
                                Seu navegador nao suporta esse tipo de arquivo.
                              </video>
                            </div>
                            <div className="bubble-media__mediaInfo">
                              <span className="bubble-media__fileType">
                                <img
                                  className="bubble-media__fileIcon"
                                  src={AVI}
                                  alt=""
                                />
                              </span>
                              <span className="bubble-media__fileName">
                                <p className="bubble-media__text">
                                  {get_name[6]}
                                </p>
                                <br />
                                <div className="fileinfo__bar">
                                  <span className="fileinfo__size">{size}</span>{" "}
                                  •{" "}
                                  <span className="fileinfo__type">
                                    {separador[1].toUpperCase()}
                                  </span>
                                </div>
                              </span>
                              {(() => {
                                if (InfoUsers.permdownload === true) {
                                  return (
                                    <div className="bubble-media__download">
                                      <a
                                        href={
                                          connection_platform.type_connect +
                                          "://" +
                                          ipcurrent +
                                          url
                                        }
                                        target="_blank"
                                        download
                                        className="bubble-media__btnDownload"
                                      >
                                        <i className="material-icons">
                                          get_app
                                        </i>
                                      </a>
                                    </div>
                                  );
                                }
                              })()}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                    break;
                }
              })}
              {typing_w}
            </div>
            <div className="block-footer">
              <div className="message-box">
                <div className="input-message">
                  <div
                    onKeyPress={this.handleKeyPress}
                    autoComplete="off"
                    type="text"
                    // ref={(node) => {
                    //   input = node;
                    // }}
                    className="chat-message"
                    ref={(input) => {
                      this.textInput = input;
                    }}
                    id="chat-message"
                    onKeyDown={this.handleKeyDown}
                    onKeyUp={(event) =>
                      this.handleOnChange(event, InfoUsers, Chat)
                    }
                    contentEditable="true"
                  ></div>
                  <button
                    type="submit"
                    onClick={(event) =>
                      this.ButtonSendMessage(
                        event,
                        InfoUsers.id,
                        InfoUsers,
                        Chat,
                        "0"
                      )
                    }
                    className="send-message btn btn--only-icon-mini-chat"
                  >
                    <i className="material-icons">send</i>
                  </button>
                </div>
                <a
                  onClick={this.DisplayQuickAnswer.bind(this)}
                  className="btn action with-icon"
                  id="action-premade-messages"
                  data-tippy="Mensagens predefinidas"
                >
                  <i className="material-icons">chat_bubble_outline</i>
                </a>
                <div
                  className={
                    this.state.buttonQuickAnswer
                      ? "premade-msg active"
                      : "premade-msg"
                  }
                >
                  <p className="premade-msg__title">Mensagens Predefinidas</p>
                  <div className="premade-msg__content">
                    <ul className="premade-msg__list">
                      {this.state.respostas.map((resp) => (
                        <li
                          key={resp.qck_asw_id}
                          className="premade-msg__item"
                          onClick={(event) =>
                            this.InsertQuickAnswer(
                              event,
                              resp.qck_asw_answer,
                              resp.editable,
                              resp.mimetypeid,
                              resp.filepath,
                              InfoUsers,
                              ContactId
                            )
                          }
                        >
                          {resp.qck_asw_keyword}
                        </li>
                      ))}
                    </ul>
                    <div className="premade-msg__input-wrapper">
                      <input
                        type="text"
                        className="premade-msg__search-input"
                        onChange={(event) =>
                          this.filterList(event, this.state.respostasinicial)
                        }
                        placeholder="Pesquise uma resposta..."
                      />
                      <span className="premade-msg__input-icon">
                        <i className="material-icons">search</i>
                      </span>
                    </div>
                  </div>
                </div>
                {/* <a
                  href="#"
                  disabled
                  className="btn action with-icon"
                  id="action-attachment"
                  data-tippy="Adicionar Anexo"
                >
                  <label htmlFor="file-input" className="material-icons">
                    attach_file
                  </label>
                  <input
                    style={{ display: "none" }}
                    disabled
                    type="file"
                    name="upload"
                    id="file-input"
                    onChange={(event) =>
                      this.handleselectedFile(event, InfoUsers, ContactId)
                    }
                  />
                </a>
                <a
                  href="#"
                  className="btn action with-icon"
                  id="action-voice"
                  data-tippy="Atender em voz"
                >
                  <i className="material-icons">mic</i>
                </a> */}
              </div>
            </div>
          </div>
          <div className="block transparent active-chats" id="active-chats">
            <div className="active-chats__tabs">
              <ul className="active-chats__list" id="active-chats__list">
                <ChatSimultComponent
                  chatemcurso={this.state.chat}
                  remotescreen={"chatinternal"}
                />
              </ul>
            </div>
          </div>
          <input type="hidden" id="simulation_click" name="simulation_click" />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatInternal);
